const AssessorNameAddressUpdateListHeader = [
  {
    text: 'Updated',
    value: 'isItUpadtedToTaxInquiryCollection',
    sortable: false,
    formatter: 'flagToYorEmpty',
  },
  {
    text: 'Tax Year',
    value: 'importTaxYear',
    sortable: false,
  },
  {
    text: 'Tax ID',
    value: 'importTaxId',
    sortable: false,
  },
  {
    text: 'Name1',
    value: 'name1',
    sortable: false,
  },
  {
    text: 'Name1, Name2',
    value: 'importName1',
    formatter: 'combineName',
    combineTextFileds: ['importName1', 'importName2'],
    enableLine: true,
    class: 'with-divider-left',
    sortable: false,
  },
  {
    text: 'C/O Name1, C/O Name2',
    value: 'importCareOfName1',
    formatter: 'combineName',
    combineTextFileds: ['importCareOfName1', 'importCareOfName2'],
    sortable: false,
  },
  {
    text: 'Address1, Address2',
    value: 'importAddress1',
    formatter: 'combineName',
    combineTextFileds: ['importAddress1', 'importAddress2'],
    sortable: false,
  },
  {
    text: 'Address3, Address4',
    value: 'importAddress3',
    formatter: 'combineName',
    combineTextFileds: ['importAddress3', 'importAddress4'],
    sortable: false,
  },
  {
    text: 'City, State, Zip Code',
    value: 'importCity',
    formatter: 'combineName',
    combineTextFileds: ['importCity', 'importState', 'importZip'],
    sortable: false,
  },
  {
    text: 'Deed Book',
    value: 'importDeedBk',
    sortable: false,
  },
  {
    text: 'Deed Page',
    value: 'importDeedPg',
    sortable: false,
  },
  {
    text: 'Grantor Name',
    value: 'importGrantorName',
    sortable: false,
  },
  {
    text: 'Sale Date',
    value: 'importSaleDate',
    formatter: 'shortDate',
    sortable: false,
  },
];

const AssessorNameAddressUpdateHeadersTwo = {
  MainHeadersNames: [
    {
      text: 'Current Treasurer\'s Owner Info',
      cols: '4',
      id: 2,
    },
    {
      text: 'Assessor\'s Owner Info',
      cols: '9',
      cellClass: 'with-divider-left',
      id: 3,
    },
  ],
};

// True when an address line is already the same care-of name about to be
// written there (ignoring a leading '%' or 'C/O' and case). Mirrors the
// backend's isSameCareOfLine in assessorNameAddressUpdateFiles.util.js so
// "Update All" (which rebuilds this suggestion server-side with no panel to
// copy) always produces the same record as this component's suggestion.
const isSameCareOfLine = (line, name) => (line || '')
  .replace(/^%\s*/, '')
  .replace(/^c\/o\s*/i, '')
  .trim()
  .toLowerCase() === (name || '').trim().toLowerCase();

// True when the new-owner name should push the existing Address 1 line down
// into Address 2 (and so on) before Address 1 is overwritten with the
// '% NAME'/'C/O NAME' care-of line -- i.e. Address 1 already holds something
// that is NOT already this same care-of line. Kept a pure function so it can
// be unit tested without mounting AssessorUpdate.vue.
const shouldShiftAddressLinesForNewOwner = (currentAddress1, newOwnerName) => {
  const addr1 = (currentAddress1 || '').trim();
  return Boolean(addr1) && !isSameCareOfLine(addr1, newOwnerName);
};

export {
  AssessorNameAddressUpdateListHeader, AssessorNameAddressUpdateHeadersTwo,
  isSameCareOfLine, shouldShiftAddressLinesForNewOwner,
};
